import { EmptyState } from '@agentic/ui-kit';
import { createFileRoute } from '@tanstack/react-router';
import { hasRole } from '../../../../app/roles.ts';
import { useMe } from '../../../../app/use-me.ts';
import { pluginRoutes } from '../../../../plugins/registry.ts';

/** Mounts plugin pages at `/x/<plugin id>/<path>`. */
export const Route = createFileRoute('/_app/x/$pluginId/$')({ component: PluginPage });

function PluginPage() {
  const { pluginId, _splat } = Route.useParams();
  const me = useMe();
  const path = (_splat ?? '').replace(/\/$/, '');
  const route = pluginRoutes().find((r) => r.pluginId === pluginId && r.path.replace(/\/$/, '') === path);
  if (!route)
    return (
      <EmptyState title="Plugin page not found">No plugin registered {`/x/${pluginId}/${path}`}.</EmptyState>
    );
  if (route.roles && !hasRole(me, route.roles)) return <EmptyState title="Not available for your role" />;
  const Component = route.component;
  return (
    <div className="pb-6">
      <Component />
    </div>
  );
}
